'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import NProgress from 'nprogress'
import React, { useEffect } from 'react'

const RouterProgress = React.memo(
  () => {
    const pathname = usePathname()
    const searchParams = useSearchParams()

    useEffect(() => {
      NProgress.configure({
        easing: 'ease',
        speed: 500,
        showSpinner: false,
        minimum: 0.1,
        trickleSpeed: 200,
      })
    }, [])

    useEffect(() => {
      NProgress.start()
      NProgress.done()
    }, [pathname, searchParams])

    return (
      <style>
        {`
        #nprogress {
          pointer-events: none;
        }

        #nprogress .bar {
          background: var(--primary-color, #29d);
          position: fixed;
          z-index: 1031;
          top: 0;
          left: 0;
          width: 100%;
          height: 3px;
        }

        #nprogress .peg {
          display: block;
          position: absolute;
          right: 0px;
          width: 100px;
          height: 100%;
          box-shadow: 0 0 10px var(--primary-color, #29d), 0 0 5px var(--primary-color, #29d);
          opacity: 1.0;
          transform: rotate(3deg) translate(0px, -4px);
        }

        .nprogress-custom-parent {
          overflow: hidden;
          position: relative;
        }

        .nprogress-custom-parent #nprogress .bar {
          position: absolute;
        }
      `}
      </style>
    )
  },
  () => true,
)

export default RouterProgress
